import { render, staticRenderFns } from "./authComponent.vue?vue&type=template&id=e2909baa&"
import script from "./authComponent.vue?vue&type=script&lang=js&"
export * from "./authComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports